import { Alert, Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import { useBookingFlowContext } from '../../../booking-flow/BookingFlowProvider';
import type { TransferFlowState } from '../flowConfig';

export function TransferDocumentStep() {
  const flow = useBookingFlowContext<TransferFlowState>();
  const booking = flow.state.cart?.transferBookings?.[0];
  const isFinalized = flow.state.cart?.isFinalized;

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="subtitle1" gutterBottom>
        Rezervasyon Belgesi
      </Typography>
      {isFinalized ? (
        <Alert severity="success" sx={{ mb: 2 }}>
          Rezervasyon kesinleştirildi.
        </Alert>
      ) : (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Rezervasyon henüz kesinleşmedi.
        </Alert>
      )}
      <Stack spacing={1} sx={{ mb: 2 }}>
        <Typography variant="body2">PNR: {booking?.pnr ?? '—'}</Typography>
        <Typography variant="body2">Referans No: {booking?.referenceNumber ?? '—'}</Typography>
        <Typography variant="body2">Sepet No: {flow.state.shoppingCartId ?? '—'}</Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {booking?.status && <Chip size="small" label={`Durum: ${booking.status}`} />}
          {booking?.provider && <Chip size="small" label={`Sağlayıcı: ${booking.provider}`} />}
        </Box>
        <Typography variant="body2">
          Toplam Tutar: {booking?.totalFare?.toLocaleString('tr-TR')} {booking?.currency}
        </Typography>
      </Stack>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="outlined" onClick={flow.reset}>
          Yeni Arama
        </Button>
      </Box>
    </Paper>
  );
}
